import {Observable, of} from 'rxjs';
import {GraphService} from '../graph.service';
import {GraphCompanyResponse} from '../../models/company-page-response';

export class GraphServiceMock implements GraphService {
    getCompany(): Observable<GraphCompanyResponse> {
        return of({name: 'Recognize', kvwNumber: '0001'});
    }
}
